module.exports = {"id":"206631","name":"Kelyn Rowe","rating":"71","photo":"./data/images/photos/0/206631.png","club":{"name":"New England","logo":"./data/images/clubs/NewEngland.png"},"positions":["MC","MD","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KelynRowe0.json
// module id = 2316
// module chunks = 0